'use strict';

var _Number$isNaN = require("@babel/runtime-corejs3/core-js-stable/number/is-nan");

module.exports = _Number$isNaN || function (x) {
  return x !== x;
};